/* DeZeroaTres Lab — animaciones y personalizador */
(function () {
  var root = document.documentElement;
  root.classList.add('dz-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }

  function scan(scope) {
    scope = scope || document;
    var cards = scope.querySelectorAll('main product-card');
    cards.forEach(function (card, i) {
      if (card.closest('dialog') || card.classList.contains('dz-reveal')) return;
      card.classList.add('dz-reveal');
      card.style.setProperty('--dz-delay', ((i % 4) * 0.08) + 's');
    });
    scope.querySelectorAll('.dz-reveal:not(.is-visible)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-visible');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  setTimeout(function () { document.querySelectorAll('.dz-reveal:not(.is-visible)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-visible'); }); }, 2500);

  var mvRequested = false;
  function loadModelViewer() {
    if (mvRequested || customElements.get('model-viewer')) return;
    mvRequested = true;
    setTimeout(function () {
      if (!customElements.get('model-viewer')) {
        var s = document.createElement('script');
        s.type = 'module';
        s.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
        document.head.appendChild(s);
      }
    }, 600);
  }

  function norm(x) { return (x || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function parts(alt) { return norm(alt).split(/\s*[\/|,+]\s*|\s+y\s+/); }

  class DzPersonalizer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      try { this.media = JSON.parse((this.querySelector('script[data-dz-media]') || {}).textContent || '[]'); } catch (e) { this.media = []; }
      this.img = this.querySelector('[data-dz-preview]');
      if (this.img) { this.defSrc = this.img.getAttribute('src'); this.defSet = this.img.getAttribute('srcset'); this.defAlt = this.img.getAttribute('alt'); }
      this.hint = this.querySelector('[data-dz-hint]');
      this.mv = this.querySelector('model-viewer');
      this.addEventListener('change', function () { self.update(); });
      var vis = this.querySelector('[data-dz-text]');
      var hid = this.querySelector('[data-dz-text-hidden]');
      if (vis && hid) {
        vis.addEventListener('input', function () {
          hid.value = vis.value.trim();
          hid.disabled = !hid.value;
          var out = self.querySelector('[data-dz-sum="text"]');
          if (out) { out.hidden = !hid.value; var b = out.querySelector('b'); if (b) b.textContent = hid.value; }
        });
      }
      if (this.mv) { this.mv.addEventListener('load', function () { self.update(); }); loadModelViewer(); }
      this.update();
    }
    pick(role) {
      var i = this.querySelector('[data-dz-group="' + role + '"] input:checked');
      return i ? { name: i.value, hex: i.dataset.hex, metal: i.dataset.metal === 'true' } : null;
    }
    update() {
      var p = this.pick('primary');
      var s = this.pick('secondary');
      var fin = this.querySelector('[data-dz-finish]');
      var f = fin ? fin.value : '';
      var self = this;
      [['primary', p], ['secondary', s]].forEach(function (pair) {
        var role = pair[0], val = pair[1];
        if (!val) return;
        var g = self.querySelector('[data-dz-group="' + role + '"] [data-dz-current]');
        if (g) g.textContent = val.name;
        var sum = self.querySelector('[data-dz-sum="' + role + '"]');
        if (sum) {
          var dot = sum.querySelector('i');
          if (dot) { dot.style.setProperty('--sw', val.hex); dot.classList.toggle('is-metal', val.metal); }
          var b = sum.querySelector('b'); if (b) b.textContent = val.name;
        }
      });
      var sf = this.querySelector('[data-dz-sum="finish"] b');
      if (sf) sf.textContent = f;
      if (this.mv && this.mv.model) this.paint(p, s, f);
      if (this.img) this.swap(p, s);
    }
    paint(p, s, f) {
      var mats = this.mv.model.materials || [];
      if (!mats.length) return;
      function find(re, idx) { for (var k = 0; k < mats.length; k++) { if (re.test(mats[k].name || '')) return mats[k]; } return mats[idx]; }
      var m1 = find(/princ|cuerpo|main|body/i, 0);
      var m2 = mats.length > 1 ? find(/secun|detal|second|detail/i, 1) : null;
      var rough = /brill/i.test(f) ? 0.18 : (/satin/i.test(f) ? 0.45 : 0.85);
      function apply(m, c) {
        if (!m || !c) return;
        var pbr = m.pbrMetallicRoughness;
        pbr.setBaseColorFactor(c.hex);
        pbr.setMetallicFactor(c.metal ? 0.9 : 0);
        pbr.setRoughnessFactor(c.metal ? 0.3 : rough);
      }
      apply(m1, p);
      if (m2 && m2 !== m1) apply(m2, s);
    }
    swap(p, s) {
      var hit = null;
      if (p) {
        var pn = norm(p.name), sn = s ? norm(s.name) : '';
        if (sn) hit = this.media.find(function (m) { var a = parts(m.alt); return a.indexOf(pn) > -1 && a.indexOf(sn) > -1; }) || null;
        if (!hit) hit = this.media.find(function (m) { return parts(m.alt)[0] === pn; }) || null;
      }
      var img = this.img;
      var src = hit ? hit.src : this.defSrc;
      var self = this;
      if (img.getAttribute('src') !== src) {
        img.classList.add('is-swapping');
        setTimeout(function () {
          if (hit) { img.removeAttribute('srcset'); img.alt = hit.alt; }
          else { if (self.defSet) img.setAttribute('srcset', self.defSet); img.alt = self.defAlt || ''; }
          img.src = src;
          img.classList.remove('is-swapping');
        }, 180);
      }
      this.classList.toggle('is-match', !!hit);
      if (this.hint) this.hint.textContent = hit ? this.hint.dataset.match : this.hint.dataset.ref;
    }
  }
  if (!customElements.get('dz-personalizer')) customElements.define('dz-personalizer', DzPersonalizer);
})();
